import { Redirect } from 'expo-router';
import React from 'react';

import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import type { ContainerComponent } from '../../../common/types/Common';
import {
    isActiveMember,
    isFormerMember,
} from '../../../common/utils/userUtils';

const HandleRedirectFromFormerMemberPortal: ContainerComponent = ({
    children,
}) => {
    const user = useAuthedUser();

    if (isActiveMember(user)) {
        return <Redirect href="/home" />;
    }

    if (!isFormerMember(user)) {
        return <Redirect href="/no-access" />;
    }

    return <>{children}</>;
};

export default HandleRedirectFromFormerMemberPortal;
